<pk-broker-navbar
	*ngIf="appReady || directReady"
	[isDirect]="directReady"
	[isBillReader]="billReaderReady"
	[isPopupWindow]="isPopupWindow"
	[isEnergyPortal]="energyPortalReady"
	(userUpdated)="onUserUpdated($event)"
	(agentUpdated)="onAgentUpdated($event)"
	(footerLogoUpdated)="onFooterLogoUpdated($event)"
	(energyPortalLogoUpdated)="onEnergyPortalLogoUpdated($event)"
	(useDefaultUpdated)="onUseDefaultUpdated($event)">
</pk-broker-navbar>

<router-outlet></router-outlet>

<pk-broker-footer
	*ngIf="appReady || directReady"
	[isDirect]="directReady"
	[isBillReader]="billReaderReady"
	[user]="user"
	[agent]="agent"
	[useDefault]="useDefault"
	[isEnergyPortal]="energyPortalReady"
	[defaultFooterLogoAttachment]="defaultFooterLogoAttachment"
	[defaultEnergyPortalLogoAttachment]="defaultEnergyPortalLogoAttachment">
</pk-broker-footer>
